import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
} from "~/components/Forms";

function HostInfoFormAdd({onHandleSubmit})
{
	const initialValues = {
		domain: '',
	}

	const validationSchema = Yup.object().shape({
		domain: Yup.string().required('Bạn chưa nhập tên miền')
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) =>
	{
		await onHandleSubmit(data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Yêu cầu</p>
			<Controller control={control} name="domain" render={({field}) => (
				<InputField label="Tên miền" errors={errors} {...field} />
			)}/>
			<hr/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Thêm yêu cầu</Button>
			</div>
		</form>
	)
}

export default HostInfoFormAdd;